import api from '@/services/api/fileManagement'

export default {
  state: {
    filesTotalNum: 0,
    modelView:'table'
  },

  mutations: {
    SET_FILESTOTALNUM: (state, data) => {
      state.filesTotalNum = data
    },
    MODELVIEW_SET:(state, data) => {
      state.modelView = data
    }
  },
  actions: {
    geFilesNum({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .getFilesNum(params)
          .then((res) => {
            commit('SET_FILESTOTALNUM', res.number_of_files)
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          })
      })
    }
  }
}
